<!--
 * @Author: hfxie
 * @Date: 2022-02-16 14:52:54
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2023-09-11 10:15:54
 * @Description: 甘特图左侧结构树WBS表头
-->

<template>
  <!-- 表头 -->
  <div
    class="task-info-row task-info-row-head bold"
    :class="{
      'task-info-row-head-one': $store.getters.timelineShowRows < 2,
      'task-info-row-head-three': $store.getters.timelineShowRows == 3,
      'task-info-row-head-four': $store.getters.timelineShowRows > 3,
      'task-info-row-head-noAdjust': noTableLineAdjustable,
      'gantt-outbox-border': (!$store.state.viewSchem.noGanttOutBoxBorder),
    }"
  >
      <!-- 特殊单元格:树结构 -->
      <div
        class="task-info-item task-info-title"
        v-if="!$store.state.noTree"
        :style="{
          'width': $store.state.treeWidth + 'px',
          'font-size': $store.getters.treeFontSize + 'px',
        }"
        :class="{
          'task-info-item-one': $store.getters.timelineShowRows < 2,
          'task-info-item-three': $store.getters.timelineShowRows == 3,
          'task-info-item-four': $store.getters.timelineShowRows > 3,
        }"
      >
        {{$store.state.viewSchem.ganttName}}
        <div class="drag-line" @mousedown="ChangeItemWidth($event)"></div>
      </div>
      <!-- wbs单元格 -->
      <template v-for="col in colsShow">
        <div
          class="task-info-item"
          :title="col.colCaption"
          :key="col.id"
          :style="{
            'width': col.colWidth + 'px',
            'font-size': col.fontSize + 'px',
            'text-align': col.colAlign,
          }"
          :class="{
            'task-info-item-one': $store.getters.timelineShowRows < 2,
            'task-info-item-three': $store.getters.timelineShowRows == 3,
            'task-info-item-four': $store.getters.timelineShowRows > 3,
          }"
        >
          {{ col.colCaption }}
          <div class="drag-line" @mousedown="ChangeItemWidth($event, col.sourceIndex)"></div>
        </div>
      </template>
  </div>

</template>

<script>

export default {
  name: "FormHeader",
  data() {
    return {

    };
  },
  props: {
    colsShow: {
      type: Array,
      default: () => { return []; },
    },
  },
  computed: {
    noTableLineAdjustable() {
      return this.$store.state.viewSchem.tableLineAdjustable === false;
    },
  },
  methods: {
    // 拉伸
    ChangeItemWidth(e, _index) {
      const _self = this;
      (!this.noTableLineAdjustable) &&
      _self.$utils.getAuthentication(_self.$store.state.accessLevel, [1, 2]) &&
      (() => {
        const odivParent = e.currentTarget.parentNode; // 获取目标父元素
        const dx = e.clientX; // 当你第一次单击的时候，存储x轴的坐标
        const dw = odivParent.offsetWidth; // 存储默认的div的宽度
        const _offsetLeft = odivParent.offsetLeft; // 存储默认的div的距左宽度
        const _uuid = _self.$store.state.uuid;
        const _obj = {}; // 后端缓存数据
        document.getElementById(_uuid).onmousemove = _self.$utils.throttle((e) => {
          let _tableWidth = dw + (e.clientX - dx); // 最新父容器宽度
          const wbsNode = document.getElementById(_self.$store.state.uuid).getElementsByClassName("wbs-box")[0];
          const _wbsViewWidth = parseInt(wbsNode.style.width);
          const _wbsScrolL = wbsNode.scrollLeft;
          const max = _wbsScrolL + _wbsViewWidth - _offsetLeft; // 窗口+已滚动距离
          const min = 50;
          if (_tableWidth <= min) {
            _tableWidth = min;
          }
          if (_tableWidth >= max) {
            _tableWidth = max;
          }

          if (typeof _index == "number" && _index >= 0) {
            const _newWbsHeaderArr = _self.$utils.deepClone(_self.$store.state.wbsHeaderArr);
            _newWbsHeaderArr[_index].colWidth = _tableWidth;
            _self.$store.commit("set_wbsHeaderArr", _newWbsHeaderArr);

            _obj.width = _tableWidth;
            _obj.index = _index;

          } else {
            _self.$store.commit("set_treeWidth", _tableWidth);

            _obj.width = _tableWidth;
          }

        }, 20, false);
        document.getElementById(_uuid).onmouseup = () => {
          document.getElementById(_uuid).onmousemove = null;
          document.getElementById(_uuid).onmouseup = null;
          // 更新后端缓存
          if (_obj.width) {
            if (typeof _index == "number" && _index >= 0) {
              _self.$store.dispatch("_set_wbsHeaderArr", _obj);
            } else {
              _self.$store.dispatch("_set_treeWidth", _obj);
            }
          }
        };
        e.stopPropagation();
        e.preventDefault();
        return false;

      })();
    },

  },
};
</script>

<style scoped lang='less'>
@import './FormHeader.less';

</style>
